"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Toggle_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/Toggle.vue"));
const ColumnTree_vue_1 = __importDefault(require("./ColumnTree.vue"));
const TabularAnalyticsController_1 = __importDefault(require("../modules/controllers/TabularAnalyticsController"));
let CustomizePanelInside = class CustomizePanelInside extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.TABULAR_ANALYTICS_CONTROLLER = TabularAnalyticsController_1.default.getInstance();
        /*     tree: ColumnNode[] = [
                {
                    key: 'recommendations',
                    label: 'Recommendations',
                    checked: false
                },
                {
                    key: 'needs',
                    label: 'Needs',
                    children: [
                        {
                            key: 'nutrition',
                            label: 'Nutrition',
                            checked: false
                        },
                        {
                            key: 'diseases',
                            label: 'Diseases',
                            checked: false
                        },
                        {
                            key: 'biosustainability',
                            label: 'Biosustainability',
                            checked: false
                        },
                    ],
                    checked: false
                },
                {
                    key: 'metrics',
                    label: 'Metrics',
                    children: [
                        {
                            key: 'biosustainability-m',
                            label: 'Biosustainability',
                            children: [
                                {
                                    key: 'rate',
                                    label: 'Rate',
                                    checked: false
                                },
                                {
                                    key: 'sec-c',
                                    label: 'Pot.Sec.Carbono',
                                    checked: false
                                },
                                {
                                    key: 'hom',
                                    label: 'Global HOM',
                                    checked: false
                                },
                                {
                                    key: 'str',
                                    label: 'Global Stress',
                                    checked: false
                                },
                                {
                                    key: 'c',
                                    label: 'Global C',
                                    checked: false
                                },
                                {
                                    key: 'bio',
                                    label: 'BioSustainability',
                                    checked: false
                                },
                            ],
                            checked: false
                        },
                        {
                            key: 'nutrition',
                            label: 'Nutrition',
                            children: [
                                {
                                    key: 'npk',
                                    label: 'NPK',
                                    checked: false
                                },
                                {
                                    key: 'minor',
                                    label: 'Minor Nutrients',
                                    checked: false
                                },
                            ],
                            checked: false
                        },
                        {
                            key: 'healthiness',
                            label: 'Healthiness',
                            children: [
                                {
                                    key: 'major',
                                    label: 'Diseases',
                                    checked: false
                                },
                                {
                                    key: 'biocontrol',
                                    label: 'BioControl',
                                    checked: false
                                },
                            ],
                            checked: false
                        },
                        {
                            key: 'phch',
                            label: 'PhCh',
                            children: [],
                            checked: false
                        },
                    ],
                    checked: false
                },
            ] */
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    changeMode(m) {
        this.$emit('changeMode', m);
    }
    changeUnits(u) {
        this.$emit('changeUnits', u);
    }
    toggle(a, b) {
        this.$emit('toggle', a, b);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], CustomizePanelInside.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], CustomizePanelInside.prototype, "tree", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CustomizePanelInside.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CustomizePanelInside.prototype, "unit", void 0);
CustomizePanelInside = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, Toggle: Toggle_vue_1.default, Separator: bmk_ui_framework_1.Separator, ColumnTree: ColumnTree_vue_1.default },
    })
], CustomizePanelInside);
exports.default = CustomizePanelInside;
